import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '../../../Checkbox/Checkbox.scss';


export class defaultRenderer extends Component {
  render() {
    const { label, option } = this.props;
    const noMarginLeft = {
      marginLeft: '0',
    };

    return (
      <div>
        <span style={noMarginLeft}>
          <span style={noMarginLeft}>{option.label ? label : '(no name)'}</span>
        </span>
      </div>
    );
  }
}

defaultRenderer.propTypes = {
  label: PropTypes.string.isRequired,
  option: PropTypes.object,
};
